import React, { Fragment, memo, useEffect, useState } from 'react'
import { withStyles } from '@material-ui/core/styles'
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'
import LOG from '../../logging/Logger'

// use withStyles rather than makeStyles as don't know how to let parent override styles otherwise
const styles = theme => ({ areaSelect: {} })

export default withStyles(styles)(
  memo(({ classes, area, onSetArea, showLabel = true, getAreas, decrypt }) => {
    LOG.debug('Render: AreaSelect')

    const [areas, setAreas] = useState(getAreas(false))

    useEffect(() => {
      setAreas(getAreas(false))
    }, [getAreas])

    return (
      <Fragment>
        {areas && areas.length > 0 && (
          <FormControl className={classes.areaSelect}>
            {showLabel && <InputLabel shrink>Area</InputLabel>}
            <Select
              MenuProps={{
                disablePortal: true
              }}
              value={area || ''}
              label='List'
              onChange={e => (onSetArea ? onSetArea(e.target.value) : null)}
            >
              <MenuItem value=''>{'No Area'}</MenuItem>
              {areas.map(areaItem => (
                <MenuItem key={areaItem.id} value={areaItem.id}>
                  {decrypt(areaItem.name)}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
      </Fragment>
    )
  })
)
